import { buySource, insteadSign, getCustomizeInfo } from '@/fetch/api/personal.js';
import history from '@/router/history';
import { Decrypt, encryptOld } from '@/utils/encrypt.js';
import { Local } from '@/utils/local.js';
import { Button, Checkbox, message, Modal } from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { Component } from 'react';
import CompleteInfo from './CompleteInfo';
import InfoForm from '@/components/LiveRoom/form.jsx';
import { checkFaceVerify } from '@/fetch/api/face.js';
import './style.less';
import { convertCurrency, getIdentityStr } from './utils';
import CustomInfoModal from '@/components/CustomInfoModal'; // 自定义完善信息

import FaceInfo from '@/components/FaceModal/FaceInfo.jsx';
import FaceIframe from '@/components/FaceModal/FaceIframe.jsx';
import SpinLoading from '@/components/SpinLoading';
const {
  confirm
} = Modal;
let windowOpen = null;

class ClassTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      protocolModalVisible: false,
      // 同意协议弹框
      sign_content: null,
      protocolValue: undefined,
      // 同意协议复选框
      ctitle: null,
      ctname: null,
      // 课程名称
      infoModalVisible: false,
      // 完善协议信息弹框
      deficiencyInfo: {},
      // 完善协议信息字段
      infoModalData: {
        name: null,
        identityId: undefined,
        identityTypeCode: null,
        mobile: null,
        educationCode: undefined,
        province: undefined,
        county: undefined,
        city: undefined,
        addressDetail: null,
        sex: null
      },
      // 完善协议信息弹框数据
      item: {},
      user: {},
      currentDomain: window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://ts.dev-s.yunduoketang.cn',
      isInfoFinished: false,
      masterId: null,
      buySource: 0,
      classPackageId: null,
      classTypeId: null,
      existsData: {},
      customObj: {},
      modalVisible: false,
      faceIframeFlag: false,
      // 人脸识别验证
      faceInfoFlag: false,
      // 人脸识别完善信息
      faceInfoData: {},
      // 人脸识别回显信息
      loading: false,
      // loading次数
      buySource: {}
    };
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  goDetail = item => {
    this.setState({
      ctname: item.courseName,
      item
    });

    if (item.liveFlag || item.meetFlag) {
      // 面授和一对一进入直播间
      buySource(item.classTypeId, {
        domain: this.state.currentDomain
      }).then(res => {
        if (res.code == '1') {
          // res.data 1课程/2课程包
          this.setState({
            masterId: res.data.masterId,
            classTypeId: res.data.classTypeId,
            classPackageId: res.data.classPackageId,
            buySource: res.data.buySource,
            loading: true
          }, () => {
            // 判断是否需要代报考
            this.insteadSignFn(item);
          });
        }
      });
    } else {
      history.push(`/course/detail/${item.commodityId}/${item.courseId}/contents`); // window.open(`${process.env.REACT_APP_PERSONAL_URL}/sysConfigItem/selectDetail/${item.commodityId}`)
    }
  };
  insteadSignFn = item => {
    insteadSign({
      classTypeId: this.state.buySource == 1 ? this.state.classTypeId : undefined,
      classPackageId: this.state.buySource == 2 ? this.state.classPackageId : undefined,
      domain: this.state.currentDomain
    }).then(res => {
      console.log(res);

      if (res.code == '1') {
        if (res.data != 0) {
          this.setState({
            loading: false
          }); // 代报考

          Modal.info({
            title: "提示",
            content: '请到个人设置完善代报考材料。',
            okText: '确定',
            icon: null,

            onOk() {
              // history.push(`/personal/instead/fill/${res.data}`);
              history.push('/personal/course/apply?apply=true');
            }

          });
        } else {
          // 不需要代报考
          // 检测是否签署协议
          if (this.state.buySource == 1) {
            // 检测课程是否签署协议
            this.checkShowProtocol(item);
          } else {
            // 检测课程包是否签署协议
            this.protocolClassPackage(item);
          }
        }
      }
    });
  };
  checkShowProtocol = item => {
    // 检测是否签署协议
    let {
      liveCompanyType,
      liveClassType,
      studentUrlGh,
      lessonId,
      classTypeId,
      commodityId,
      teachmethod,
      status,
      protocolId
    } = item;
    axios({
      url: `${this.state.currentDomain}/coursePotocolUserRelation/checkShowProtocol`,
      method: 'post',
      params: {
        protocolId,
        classTypeId,
        comId: commodityId
      }
    }).then(res => {
      if (res) {
        if (res.data.pass) {
          // 已经签署
          this.toLiveRoom(item);
        } else {
          // 检测协议模版信息是否完善
          this.checkDatePerfect(item, res.data);
        }
      }
    });
  };
  checkDatePerfect = (item, data) => {
    // 检测协议模版信息是否完善
    const {
      buySource
    } = this.state;
    let classTypeIdTemp = buySource == 2 ? data.classPackageId : item.classTypeId;
    let typeNum = buySource == 2 ? 1 : 0;
    var config = data.config;
    var user = data.user;
    var sex = data.stuSex;

    if (sex && sex == 'male') {
      sex = "男";
    } else if (sex && sex == 'female') {
      sex = "女";
    }

    var classType = data.classType ? data.classType : {};
    var education = data.stuEducation;
    var address = data.stuAddress;
    var rp = null;
    var sign_content = '';
    this.setState({
      ctname: item.courseName,
      ctitle: config.title,
      user: user
    });
    axios({
      url: `${this.state.currentDomain}/student/validatePerfectStudentInfo/${classTypeIdTemp}/${typeNum}`,
      method: 'get'
    }).then(res => {
      this.setState({
        loading: false
      });

      if (res && res.data.msg == 'success') {
        if (config.protocolType == 1) {
          // 电子协议
          this.goToEleModal(item, config, data.classPackageId);
        } else {
          // 普通协议
          // 已经完善协议资料，同意协议
          var now = moment(new Date()).format('YYYY-MM-DD'); // 判断是课程还是课程包1课程2课程包

          if (this.state.buySource == 1) {
            sign_content = decodeURI(config.content).replace(/\[username\]/g, user.name ? user.name : '').replace(/\[coursename\]/g, item.courseName ? item.courseName : '').replace(/\[cardtype\]/g, getIdentityStr(user.identityTypeCode)).replace(/\[StudentIDcardnumber\]/g, user.identityId ? user.identityId : '').replace(/\[Studentcellphonenumber\]/g, user.mobile ? user.mobile : '') // .replace(/\[coursecost\]/g, item.originalprice ? item.originalprice : 0) //原价
            // .replace(/\[PreferentiaIpriceofcourse\]/g, rp ? rp : item.realPrice ? item.realPrice : 0)
            .replace(/\[coursecost\]/g, classType.originalPrice ? classType.originalPrice : 0) //原价
            .replace(/\[PreferentiaIpriceofcourse\]/g, rp ? rp : classType.realPrice ? classType.realPrice : 0).replace(/\[current date\]/g, now).replace(/\[coursepay\]/g, data && data.coursepay ? data.coursepay : "0").replace(/\[courseupperpay\]/g, convertCurrency(data && data.coursepay ? data.coursepay : "0")).replace(/\[sex\]/g, sex ? sex : "").replace(/\[education\]/g, education ? education : "").replace(/\[address\]/g, address ? address : "") // .replace(/\[Course subject\]/g, item.oneitemname ? item.oneitemname : '');
            .replace(/\[Course subject\]/g, data && data.itemOneName ? data.itemOneName : '');
          } else {
            sign_content = decodeURI(config.content).replace(/\[username\]/g, user.name ? user.name : '').replace(/\[coursename\]/g, data && data.cpName ? data.cpName : '').replace(/\[cardtype\]/g, getIdentityStr(user.identityTypeCode)).replace(/\[StudentIDcardnumber\]/g, user.identityId ? user.identityId : '').replace(/\[Studentcellphonenumber\]/g, user.mobile ? user.mobile : '') // .replace(/\[coursecost\]/g, item.originalprice ? item.originalprice : 0) //原价
            // .replace(/\[PreferentiaIpriceofcourse\]/g, rp ? rp : item.realPrice ? item.realPrice : 0)
            .replace(/\[coursecost\]/g, data && data.cpOriginalPrice ? data.cpOriginalPrice : 0) //原价
            .replace(/\[PreferentiaIpriceofcourse\]/g, rp ? rp : data.cpRealPrice ? data.cpRealPrice : 0).replace(/\[current date\]/g, now).replace(/\[coursepay\]/g, data && data.cPay ? data.cPay : "0").replace(/\[courseupperpay\]/g, convertCurrency(data && data.cPay ? data.cPay : "0")).replace(/\[sex\]/g, sex ? sex : "").replace(/\[education\]/g, education ? education : "").replace(/\[address\]/g, address ? address : "") // .replace(/\[Course subject\]/g, item.oneitemname ? item.oneitemname : '');
            .replace(/\[Course subject\]/g, data && data.cpItemName ? data && data.cpItemName : '');
          } // sign_content = decodeURI(config.content)
          //   .replace(/\[username\]/g, user.name ? user.name : '')
          //   .replace(/\[coursename\]/g, item.courseName ? item.courseName : '')
          //   .replace(/\[cardtype\]/g, getIdentityStr(user.identityTypeCode))
          //   .replace(/\[StudentIDcardnumber\]/g, user.identityId ? user.identityId : '')
          //   .replace(/\[Studentcellphonenumber\]/g, user.mobile ? user.mobile : '')
          //   .replace(/\[coursecost\]/g, item.originalprice ? item.originalprice : 0)
          //   .replace(/\[PreferentiaIpriceofcourse\]/g, rp ? rp : item.realprice ? item.realprice : 0)
          //   .replace(/\[current date\]/g, now)
          //   .replace(/\[coursepay\]/g, data.coursepay ? data.coursepay : "0")
          //   .replace(/\[courseupperpay\]/g, convertCurrency((data.coursepay ? data.coursepay : "0")))
          //   .replace(/\[sex\]/g, sex ? sex : "")
          //   .replace(/\[education\]/g, education ? education : "")
          //   .replace(/\[address\]/g, address ? address : "")
          //   .replace(/\[Course subject\]/g, item.oneitemname ? item.oneitemname : '');


          this.setState({
            // 弹框
            protocolModalVisible: true,
            sign_content
          });
        }
      } else {
        // 完善协议信息弹框
        this.setState({
          infoModalVisible: true,
          // 完善协议信息弹框
          deficiencyInfo: res.data.deficiencyInfo,
          // 完善协议信息字段
          infoModalData: res.data.result // 完善协议信息弹框数据

        });
      }
    });
  };
  goToEleModal = (item, config, classPackageId) => {
    let {
      liveCompanyType,
      liveClassType,
      studentUrlGh,
      lessonId,
      classTypeId,
      commodityId,
      teachmethod,
      status,
      protocolId
    } = item;
    const {
      buySource
    } = this.state;
    confirm({
      title: item.courseName + config.title,
      content: '签署完学习前协议后才能上课哦',
      okText: '确定',
      cancelText: '取消',
      icon: null,

      onCancel() {},

      onOk: () => {
        axios({
          url: `${this.state.currentDomain}/coursePotocolUserRelation/prepareAgreement`,
          method: 'post',
          params: {
            protocolId: buySource == 1 ? protocolId : config.id,
            type: "PC",
            comId: commodityId,
            // 课程的时候传
            classTypeId: buySource == 1 ? this.state.classTypeId : undefined,
            // 课程包的时候传
            classPackageId: buySource == 2 ? classPackageId : undefined,
            masterId: buySource == 2 ? this.state.masterId : undefined
          }
        }).then(res => {
          if (res.data.result == 'success') {
            window.location.href = res.data.resultForm.match(/action=(.*?)method/)[1];
          } else {
            message.error(res.data.msg);
          }
        });
      }
    });
  };
  confirmProtocol = item => {
    // 提交同意协议
    if (!this.state.protocolValue) {
      message.error('用户同意课程协议后方可继续学习');
      return false;
    }

    const {
      liveCompanyType,
      liveClassType,
      studentUrlGh,
      lessonId,
      classTypeId,
      commodityId,
      teachmethod,
      status,
      protocolId
    } = item;
    const {
      classPackageId,
      buySource,
      productId
    } = this.state;
    var classPackagePotocolId = null;
    axios({
      method: "post",
      url: `${this.state.currentDomain}/coursePotocolUserRelation/insertProtocol`,
      data: {
        // "productId": classPackageId ? classPackageId : classTypeId,
        "productId": classPackageId ? productId : classTypeId,
        // 'potocolId': classPackagePotocolId ? classPackagePotocolId : protocolId,
        'potocolId': buySource == 2 ? this.state.protocolId : protocolId,
        'type': classPackageId ? 'classpackage' : 'course',
        'signContent': encodeURIComponent(this.state.sign_content)
      },
      transformRequest: [function (data) {
        let ret = '';

        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }

        ret = ret.substring(0, ret.lastIndexOf('&'));
        return ret;
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      if (res) {
        this.concalProtocol();
      }
    });
  };
  confirmInfo = () => {
    // 提交完善的用户信息
    let isError = this.formDataRef.checkData();

    if (!isError) {
      let formData = this.formDataRef.props.form.getFieldsValue(); // 检测手机号是否和之前绑定是否一致

      if (formData.mobile) {
        if (formData.mobile == this.state.user.mobile || formData.smsCode) {
          this.confirmUseInfoHtp();
        } else {
          // 手机号码变更
          this.formDataRef.showSliderValid(true);
        }
      } else {
        this.confirmUseInfoHtp();
      }
    }
  };
  confirmUseInfoHtp = () => {
    // 提交完善的info
    let formData = this.formDataRef.props.form.getFieldsValue();
    console.log(this.state.item);
    formData.id = this.state.item.studentId;
    axios({
      method: "post",
      url: `${this.state.currentDomain}/student/perfectStudentInfo`,
      params: formData
    }).then(res => {
      if (res.data && res.data.data && res.data.data.msg == 'success') {
        this.cancelInfoModal();
      } else {
        message.error(res.data.message);
      }
    });
  };
  toLiveRoom = async item => {
    let {
      liveCompanyType,
      liveClassType,
      studentUrlGh,
      lessonId,
      classTypeId,
      commodityId,
      teachmethod,
      status,
      userRealPrice,
      realPrice,
      freeFlag
    } = item;

    if ((liveCompanyType == 'gh' || liveCompanyType == 'cc' && (liveClassType == null || liveClassType == '' || liveClassType == 'LIVE_BIG_CLASS_ROOM') || liveCompanyType == 'zs') && (!studentUrlGh || studentUrlGh == "null")) {
      message.error('地址不存在!');
      this.setState({
        loading: false
      });
      return false;
    } // 检测学员信息是否完善
    // let isNeedExist = await this.checkNeedExists(item, 2)
    // let isexists = null
    // isNeedExist ? isexists = await this.dataIsexists(item) : null
    // if(!isexists && isNeedExist) return false


    let res = await this.dataIsexists(userRealPrice == 0 || realPrice == 0); // 免费课程

    if ((userRealPrice == 0 || realPrice == 0) && res.containFreeCourseFlag && res.isShowPopup) return false; // 非免费

    if (userRealPrice != 0 && realPrice != 0 && res.isShowPopup) return false;

    if ([1, 2].includes(freeFlag)) {
      // 免费、试听课次不需要校验
      this.toLiveRoomCallBack();
    } else {
      this.checkFaceVerifyFn('LiveRoomCallBack', this.toLiveRoomCallBack);
    } // var str = studentUrlGh + "," + lessonId + "," + status
    //   + "," + classTypeId + "," + 1;
    // var content = encryptOld(str);
    // var url = `${process.env.REACT_APP_PERSONAL_URL}/classModule/toLiveroom?content=${content}&com=${commodityId}${encodeURI(':')}${userInfo.userId}&provide=${liveCompanyType}`
    // var windowOpen = window.open("", "_blank")
    // if (windowOpen == null || typeof(windowOpen) == 'undefined'){
    //   // message.destroy()
    //   // message.warning('窗口无法打开，请检查你的浏览器设置：浏览器 -> 偏好设置 -> 弹出式窗口 -> 允许')
    //   window.location.href = url
    // } else {
    //   windowOpen.location.href = url
    // }

  };
  toLiveRoomCallBack = () => {
    console.log('LiveRoomCallBack', 3434343434);
    const {
      item
    } = this.state;
    let userInfo = Local.get('userInfo') ? JSON.parse(Decrypt(Local.get('userInfo'))) : {};
    let {
      liveCompanyType,
      studentUrlGh,
      lessonId,
      classTypeId,
      commodityId,
      teachmethod,
      status
    } = item;
    let str = `${studentUrlGh},${lessonId},${status},${classTypeId},1`;
    let content = encryptOld(str);
    let url = `${process.env.REACT_APP_PERSONAL_URL}/classModule/toLiveroom?content=${content}&com=${commodityId}${encodeURI(':')}${userInfo.userId}&provide=${liveCompanyType}`;
    this.setState({
      loading: false
    });
    windowOpen = window.open("", "_blank");
    if (windowOpen) windowOpen.location.href = url;else window.open(url);
  };
  checkNeedExists = async (item, oprateType) => {
    let needExist = false;
    await axios({
      url: `${this.state.currentDomain}/company/checkCompanyFunctionSet`,
      method: 'get',
      params: {
        'functionCode': 'COMPANY_BUY_CHECK'
      }
    }).then(res => {
      if (!res.data || !res.data.status) {
        needExist = false;
        return;
      } //购买


      if (oprateType == 1) {
        if (Number(res.data.status) == 1 || Number(res.data.status) == 3 && item.realPrice) {
          needExist = true;
          return;
        }
      } //学习课次


      if (oprateType == 2) {
        if (Number(res.data.status) == 4 || Number(res.data.status) == 5 && item.realPrice) {
          needExist = true;
          return;
        }
      } //考试


      if (oprateType == 3) {
        if (Number(res.data.status) == 2) {
          needExist = true;
          return;
        }
      }
    });
    return needExist;
  }; // dataIsexists = async (item) => {
  //   let isexists = false
  //   await axios({
  //     url: `${this.state.currentDomain}/longitudinalTableColDefine/dataIsExistsPerfectInfo`,
  //     // url: `${this.state.currentDomain}/longitudinalTableColDefine/dataIsExists`,
  //     method: 'post',
  //   }).then(res => {
  //     isexists = res.data.isExists
  //     // isexists = res.data
  //     // if(!res.data){
  //     if(!res.data.isExists){
  //       // confirm({
  //       //   title: "提示",
  //       //   content: '',
  //       //   okText: '暂不完善',
  //       //   cancelText: '现在去设置',
  //       //   icon: null,
  //       //   onOk() {},
  //       //   onCancel: () => {
  //       //     history.push(`/personal/setting/data`);
  //       //   }
  //       // })
  //       //点击学习课程时，判断此课程是否是学习前协议，如果需要完善信息，则把完善信息和签署协议的完善信息放到一块
  //       this.studyExistsInfo(res.data, item)
  //     }
  //   })
  //   return isexists
  // }

  dataIsexists = async isRealPrice => {
    let isexists = {
      containFreeCourseFlag: false,
      isShowPopup: false
    };
    await getCustomizeInfo({
      company_id: Local.get('userInfo') ? JSON.parse(Decrypt(Local.get('userInfo'))).companyId : '',
      school_id: Local.get('schoolId') ? Local.get('schoolId') : 1,
      userId: Local.get('userInfo') ? JSON.parse(Decrypt(Local.get('userInfo'))).userId : '',
      sceneCode: 3
    }).then(res => {
      if (res.code === '1') {
        isexists = {
          containFreeCourseFlag: res.data.containFreeCourseFlag,
          isShowPopup: res.data.isShowPopup
        };

        if (isRealPrice && res.data.containFreeCourseFlag && res.data.isShowPopup || !isRealPrice && res.data.isShowPopup) {
          this.setState({
            customObj: res.data,
            modalVisible: true,
            loading: false
          });
        }
      }
    });
    return isexists;
  }; // studyExistsInfo = (dataExists, item) =>{
  //   //查看用户是否同意过课程协议
  //   let {liveCompanyType, liveClassType, studentUrlGh, lessonId, classTypeId, commodityId, teachmethod, status, protocolId} = item;
  //   getCustomizeInfo({
  //     company_id: Local.get('userInfo') ? JSON.parse(Decrypt(Local.get('userInfo'))).companyId :'',
  //     school_id:  Local.get('schoolId') ? Local.get('schoolId') : 1,
  //     userId: Local.get('userInfo') ? JSON.parse(Decrypt(Local.get('userInfo'))).userId :'',
  //     sceneCode: 3
  //   }).then((res) => {
  //     if (res.code === '1') {
  //       if (res.data.data && res.data.isShowPopup) {
  //         let arr = res.data.data.map(value => value.customizeFieldVO)
  //         arr.forEach(value => {
  //           value.field = value.fieldName
  //           value.fieldId = value.id
  //           value.fieldOptions = value.dataOptions
  //         })
  //         this.setState({
  //           modalList: arr,
  //           modalVisible: true
  //         })
  //         return;
  //       }
  //       this.showCusExist(dataExists);
  //     }
  //   })
  //   axios({
  //     url: `${this.state.currentDomain}/coursePotocolUserRelation/checkShowProtocol`,
  //     method: 'post',
  //     params: {
  //       protocolId,
  //       classTypeId,
  //       comId: commodityId
  //     }
  //   }).then(res => {
  //     if(!res.data.pass){
  //       //未签署并且需要完善信息时显示    config.protocolType == 1(电子协议 )   为0是普通协议
  //       //查询签署协议时需要完善的协议变量信息
  //       this.setState({
  //         sceneCode: 3
  //       })
  //       // this.checkDatePerfectExist(item, dataExists);
  //     } else {
  //       this.showCusExist(dataExists);
  //     }
  //   })
  // }

  checkDatePerfectExist = (item, dataExists) => {
    axios({
      url: `${this.state.currentDomain}/student/validatePerfectStudentInfo/${item.classTypeId}/0`,
      method: 'get'
    }).then(res => {
      if (res.data && res.data.msg == 'success') {
        //协议中没有需要完善的字段，则显示完善信息中的字段(根据COMPANY_BUY_CHECK配置)
        this.showCusExist(dataExists);
      } else {
        this.setState({
          loading: false,
          infoModalVisible: true,
          infoModalData: {}
        });
      }
    });
  };
  showCusExist = dataExists => {
    console.log(dataExists);
    this.setState({
      isInfoFinished: true,
      existsData: dataExists
    });
  };
  protocolClassPackage = item => {
    let {
      classTypeId
    } = item; // 课程包进入直播间的判断
    // message.warning('这是课程包的进入直播间，正在开发')

    axios({
      url: `${this.state.currentDomain}/sysConfigItem/validateAgreementProtocolClassPackage`,
      method: 'post',
      params: {
        classTypeId
      }
    }).then(res => {
      if (res) {
        let jsonData = res.data;
        jsonData.config = res.data.content;
        var config = jsonData.content || {};
        var user = jsonData.user;
        var classPackageId = jsonData.classPackageId;
        var cPay = jsonData.cPay;
        var cpRealPrice = jsonData.cpRealPrice;
        var cpOriginalPrice = jsonData.cpOriginalPrice;
        var sex = jsonData.stuSex;

        if (sex && sex == 'male') {
          sex = "男";
        } else if (sex && sex == 'female') {
          sex = "女";
        }

        this.setState({
          productId: jsonData.classPackageId,
          courseBao: jsonData
        });

        if (config.id) {
          this.setState({
            protocolId: config.id
          });
        }

        var education = jsonData.stuEducation;
        var address = jsonData.stuAddress;
        var cpName = jsonData.cpName ? jsonData.cpName : "";
        var cpItemName = jsonData.cpItemName ? jsonData.cpItemName : "";

        if (!jsonData.msg && typeof jsonData.msg != 'undefined' && typeof jsonData.isZqAgreement != 'undefined') {
          if (jsonData.isZqAgreement) {
            this.checkDatePerfect(item, jsonData);
          } else if (jsonData.simpleProtocol == true) {
            this.checkDatePerfect(item, jsonData);
          } else {
            this.toLiveRoom(item);
          }
        } else {
          this.toLiveRoom(item);
        }
      }
    });
  };
  cancelInfoModal = () => {
    this.setState({
      infoModalVisible: false
    });
  };
  agentProtocol = e => {
    this.setState({
      protocolValue: e.target.checked
    });
  };
  concalProtocol = () => {
    this.setState({
      protocolModalVisible: false
    });
  }; // cancelFinishedModal = () => {
  //   this.setState({
  //     isInfoFinished: false
  //   })
  // }
  //
  // confirmFinishedModal = () => {
  //   let isError = this.formDataRef.validateData();
  //   if(!isError){
  //     let formData = this.formDataRef.props.form.getFieldsValue()
  //     if(formData.citys){
  //       formData.province_check=formData.citys[0];
  //       formData.city_check=formData.citys[1];
  //       formData.county_check=formData.citys[2]?formData.citys[2]:"";
  //       delete formData.citys;
  //     }
  //     axios({
  //       url:`${this.state.currentDomain}/student/updateBaseInfoAndCustomInfo`,
  //       method: 'post',
  //       params: formData
  //     }).then(res => {
  //       if(res.data.result=="success"){
  //         this.setState({
  //           isInfoFinished: false
  //         })
  //       }else{
  //         message.error(res.message)
  //       }
  //     })
  //   }
  // }

  handleModalCancel = () => {
    // 点击完善信息弹窗取消
    this.setState({
      modalVisible: false
    });
  }; // 人脸识别相关

  checkFaceVerifyFn = (type, callback = () => {}) => {
    // 检测是否需要人脸识别
    checkFaceVerify({
      classTypeId: this.state.item.classTypeId || 916759,
      lessonId: this.state.item.lessonId || 3496154
    }).then(res => {
      if (res.code == 1) {
        let data = res.data || {};

        switch (data.status) {
          case 0:
            // 无需校验
            callback();
            break;

          case 1:
            //1-需校验,
            // windowOpen && windowOpen.close();
            this.setState({
              faceIframeFlag: true,
              faceType: type,
              loading: false
            });
            break;

          case 2:
            // 2-需完善姓名与身份信息
            // windowOpen && windowOpen.close();
            this.setState({
              faceInfoFlag: true,
              loading: false
            });
            break;

          default:
            break;
        }
      } else {
        message.warning(res.message);
      }
    });
  };
  successCallback = type => {
    // 人脸识别后的回调
    console.log(44444, type, this.state.faceType, this.state.faceIframeFlag);
    if (!this.state.faceIframeFlag) return false;
    this.setState({
      faceIframeFlag: false
    }, () => {
      if (type == 1) {
        // 成功
        console.log(455555555, this.state.faceType);
        this[`to${this.state.faceType}`]();
      } else if (type == 2) {//   失败
      }
    });
  };

  render() {
    const {
      state
    } = this;
    return <div data-inspector-line="776" data-inspector-column="13" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx">
      {<Modal data-inspector-line="778" data-inspector-column="8" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" title={state.buySource == 1 ? state.item.courseName + state.ctitle : this.state.courseBao && this.state.courseBao.cpName ? this.state.courseBao.cpName + state.ctitle : ""} width={750} centered className="protocol-modal" visible={state.protocolModalVisible} onCancel={this.concalProtocol} footer={[<Button data-inspector-line="786" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" key="back" onClick={this.concalProtocol}>取消</Button>, <Button data-inspector-line="787" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" key="submit" type="primary" onClick={() => this.confirmProtocol(state.item)}>确定</Button>]}>
            <div data-inspector-line="789" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" className="content" dangerouslySetInnerHTML={{
          __html: state.sign_content
        }}></div>
            <div data-inspector-line="790" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" className="checkbox">
              <Checkbox data-inspector-line="791" data-inspector-column="14" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" onChange={this.agentProtocol}>接受课程协议后可继续学习课程</Checkbox>
            </div>
        </Modal>}
      {<Modal data-inspector-line="796" data-inspector-column="8" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" title={[<h3 data-inspector-line="798" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx">完善个人信息提示</h3>, <p data-inspector-line="799" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx">在学习{state.ctname}前,请先完善以下个人信息</p>]} width={685} centered className="live-room-modal" visible={state.infoModalVisible} onCancel={this.cancelInfoModal} footer={[<Button data-inspector-line="807" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" key="back" onClick={this.cancelInfoModal}>取消</Button>, <Button data-inspector-line="808" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" key="submit" type="primary" onClick={this.confirmInfo}>确定</Button>]}>

            <InfoForm data-inspector-line="811" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" deficiencyInfo={state.deficiencyInfo} infoModalData={state.infoModalData} item={state.item} cancelInfoModal={this.cancelInfoModal} onRef={ref => this.formDataRef = ref} />
        </Modal>}
      {
        /*{*/
      }
      {
        /* <Modal*/
      }
      {
        /*    title={[*/
      }
      {
        /*      <h3>提示</h3>,*/
      }
      {
        /*      <p>在学习<b style={{color: "#222"}}>{state.ctname}</b>前,请先完善以下个人信息</p>*/
      }
      {
        /*    ]}*/
      }
      {
        /*    width={685}*/
      }
      {
        /*    centered*/
      }
      {
        /*    className="live-room-modal"*/
      }
      {
        /*    visible={state.isInfoFinished}*/
      }
      {
        /*    onCancel={this.cancelFinishedModal}*/
      }
      {
        /*    footer= {[*/
      }
      {
        /*      <Button key="back" onClick={this.cancelFinishedModal}>取消</Button>,*/
      }
      {
        /*      <Button key="submit" type="primary" onClick={this.confirmFinishedModal}>确定</Button>*/
      }
      {
        /*    ]}>*/
      }
      {
        /*    {state.existsData && <CompleteInfo  */
      }
      {
        /*      infoModalData={state.existsData}*/
      }
      {
        /*      item={state.item}*/
      }
      {
        /*      cancelInfoModal={this.cancelInfoModal} */
      }
      {
        /*      onRef={(ref)=>this.formDataRef=ref}/> || null}*/
      }
      {
        /*  </Modal>*/
      }
      {
        /*}*/
      }
      <CustomInfoModal data-inspector-line="841" data-inspector-column="6" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" visible={this.state.modalVisible} customObj={this.state.customObj} sceneCode={3} handleModalCancel={this.handleModalCancel} />
      {state.faceInfoFlag && <FaceInfo data-inspector-line="847" data-inspector-column="30" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" visible={state.faceInfoFlag} successCallback={() => this.setState({
        faceInfoFlag: false
      })} /> || null}
      {state.faceIframeFlag && <FaceIframe data-inspector-line="850" data-inspector-column="32" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" classTypeId={state.item.classTypeId} lessonId={state.item.lessonId} visible={state.faceIframeFlag} successCallback={this.successCallback} /> || null}
        {state.loading && <div data-inspector-line="855" data-inspector-column="26" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" className="loading-con"><SpinLoading data-inspector-line="855" data-inspector-column="55" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\index.jsx" /></div> || null}
    </div>;
  }

}

export default ClassTable;